import React from "react";
import { Link } from "react-router-dom";
import { labels } from "../i18n/translations";
import { WHATSAPP_NUMBER } from "../lib/whatsapp";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-[#FAFAFA] mt-24"
    >
      <div className="px-6 md:px-12 lg:px-20 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="font-heading text-2xl md:text-3xl tracking-tight">
            MB<span className="text-[#C5A059]">.</span>Réserve
          </div>
          <p className="mt-4 max-w-md text-sm md:text-base text-black/60 font-light leading-relaxed">
            {labels.footer.tagline}
          </p>
          <p className="mt-6 max-w-md text-xs text-black/40 font-light leading-relaxed">
            {labels.footer.disclaimer}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="uppercase tracking-[0.22em] text-[11px] text-black/40 mb-5">
            {labels.footer.navigation}
          </div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[#C5A059] transition-colors">{labels.nav.home}</Link></li>
            <li><Link to="/catalogo" className="hover:text-[#C5A059] transition-colors">{labels.nav.catalog}</Link></li>
            <li><Link to="/contatti" className="hover:text-[#C5A059] transition-colors">{labels.nav.contact}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="uppercase tracking-[0.22em] text-[11px] text-black/40 mb-5">
            {labels.footer.contact}
          </div>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER.replace(/[^0-9]/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="text-sm hover:text-[#C5A059] transition-colors"
          >
            WhatsApp · {WHATSAPP_NUMBER}
          </a>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-20 py-6 border-t border-black/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-black/40">
        <span>© {year} MB Réserve</span>
        <span>{labels.footer.rights}</span>
      </div>
    </footer>
  );
};

export default Footer;
